import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLoading: false,
};

const loadingSlice = createSlice({
    name: 'isLoading',
    initialState,
    reducers: {
        onLoading: (state) => {
            state.isLoading = true;
        },
        offLoading: (state) => {
            state.isLoading = false;
        },
    },
});

export const { showLoading, hideLoading } = loadingSlice.actions;
export default loadingSlice.reducer;